module.exports = __webpack_public_path__ + "static/manulife-logo-710c6d13181fd0684fb5c948cc9d3ecc.png";